import {Injectable} from '@angular/core';
import {HttpHelper} from '@shared/helpers/http.helper';
import {ResponseArray, ResponseDefault} from '@shared/interfaces/http.interface';
import {getEndpoint} from '@core/constants/api';

@Injectable({
  providedIn: 'root'
})
export class ListService extends HttpHelper {
  public API_ALL_URL: string;
  public API_ONE_URL: string;

  setAPIUrls(ALL_URL: string, ONE_URL: string): void {
    this.API_ALL_URL = ALL_URL;
    this.API_ONE_URL = ONE_URL;
  }

  getAll<T>(ids?: number[]): Promise<ResponseArray<T>> {
    let getEndpointFunc = () => getEndpoint(this.API_ALL_URL);

    if (ids) {
      const params: string[] = ids.map((id) => id.toString());
      getEndpointFunc = () => getEndpoint(this.API_ALL_URL, params);
    }

    return this.GetAll<T>(getEndpointFunc(), { params: this.getHttpParamsFromUrl() });
  }

  remove<T>(id: string): Promise<ResponseDefault> {
    return this.Delete<T>(getEndpoint(this.API_ONE_URL, [id]));
  }
}
